import { NgModule } from '@angular/core';
import { SharePublicLinkComponent } from './share-public-link.component';
import { SharedModule } from '../../shared.module';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogCustomModule } from '../mat-dialog-custom/mat-dialog-custom.module';

@NgModule({
  declarations: [SharePublicLinkComponent],
  imports: [
    SharedModule,
    MatDialogCustomModule,
    MatTooltipModule,
    ClipboardModule,
  ],
})
export class SharePublicLinkModule {}
